import React from 'react';
import { TooltipContent } from '../styled';
import { checkPassword } from '../../../utils/validation';
import { ToolTipBodyProps, PasswordResultProps } from '../types';

const ToolTipBody = (props: ToolTipBodyProps) => {
  const PasswordTestResult: PasswordResultProps = checkPassword(props.value);
  return (
    <TooltipContent>
      <p>
        <span className={`${PasswordTestResult.isInValid ? '' : 'valid'}`}>Password must contain the following:</span>
      </p>
      <p>
        {!PasswordTestResult.isAlpha ? <span className="hiphen-span">-</span> : <span className="tick-icon" />}
        <span className={`${PasswordTestResult.isAlpha ? 'valid' : ''}`}> Upper and lowercase letter (A,z)</span>
      </p>
      <p>
        {!PasswordTestResult.isNumber ? <span className="hiphen-span">-</span> : <span className="tick-icon" />}
        <span className={`${PasswordTestResult.isNumber ? 'valid' : ''}`}> Number (0-9)</span>
      </p>
      <p>
        {!PasswordTestResult.isSplChar ? <span className="hiphen-span">-</span> : <span className="tick-icon" />}
        <span className={`${PasswordTestResult.isSplChar ? 'valid' : ''}`}> Special character (!,%,@,# ....)</span>
      </p>
      <p>
        {!PasswordTestResult.isLength ? <span className="hiphen-span">-</span> : <span className="tick-icon" />}
        <span className={`${PasswordTestResult.isLength ? 'valid' : ''}`}> Minimum of (8) characters</span>
      </p>
    </TooltipContent>
  );
};

export default ToolTipBody;
